import style from './Sobre.module.scss';
import capa from './banner-gato.png'


const Sobre = () => {
  return (

    <section className={style.banner}>
      <div className={style.fundoCapa}>
        <img src={capa} alt="banner-gato" />
      </div>
      <div className={style.tituloIntro}>
        <h1>Estou Perdido</h1><h3> é um site para
          que você possa registrar seu animal desaparecido
          ou informar o resgate de algum que tenha encontrado na cidade de Uberaba - MG com o objetivo de 
          centralizar as informações dos desaparecimentos de animais.
        </h3>

        <h4 >Como registrar desaparecimento?</h4>
        <p>Acesse a aba Informar Desaparecimento no menu e registre as informações.</p>

        <h4>Como registrar um animal que encontrei?</h4>
        <p>Acesse a aba Informar Resgate no menu e registre as informações.</p>
        
      </div>
      
    </section>
  )
}

export default Sobre;